// extracted by mini-css-extract-plugin
module.exports = {"menu":"bgd9y","item":"FPbzM"};